"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _iterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _RestService = _interopRequireDefault(require("./RestService"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _BuildConstants = require("../../../../utils/BuildConstants");

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _TournamentStateHelper = _interopRequireDefault(require("../../../../helpers/TournamentStateHelper"));

var _EquizzerActions = _interopRequireDefault(require("../actions/EquizzerActions"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator2["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var GAME_STATUS = {
  IS_PLAYABLE: 0,
  IS_WAITING: 1,
  IS_FINISHED: 2
};
var DAYS_GAME_ACTIVE = 2; // in days

var TOURNAMENT_LIST_PATH = 'equeoQDTournament/list';
var TOURNAMENT_SHOW_PATH = 'equeoQDTournament/show';
var TOURNAMENT_JOIN_TEAM_PATH = 'equeoQDTournament/joinTeam';
var TOURNAMENT_LEAVE_PATH = 'equeoQDTournament/leaveTournament';

var GameService = /*#__PURE__*/function () {
  function GameService() {
    (0, _classCallCheck2["default"])(this, GameService);
  }

  (0, _createClass2["default"])(GameService, null, [{
    key: "loadAllGame",
    value: function () {
      var _loadAllGame = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(userAuth) {
        var gameData;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _RestService["default"].getGames(null, userAuth);

              case 3:
                gameData = _context.sent;
                gameData.forEach(function (game) {
                  if (game.hasOwnProperty('tournament')) {
                    var selectedOpponent = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT);

                    var playedOpponents = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_OPPONENTS_PLAYED) || {};
                    console.log('PLAYED OPPONENTS SAVING: ', selectedOpponent, playedOpponents);

                    if (selectedOpponent && playedOpponents) {
                      if (!playedOpponents[selectedOpponent.id]) {
                        playedOpponents[selectedOpponent.id] = [game.id];
                      } else {
                        if (playedOpponents[selectedOpponent.id].indexOf(game.id) < 0) {
                          playedOpponents[selectedOpponent.id].push(game.id);
                        }
                      }

                      console.log('PLAYED OPPONENTS SAVING: ', playedOpponents); // has to be permanent because user might shutdown phone and we can not recover this data

                      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_OPPONENTS_PLAYED, playedOpponents);
                    }
                  }
                });
                console.log('SUCCESS: GameService, loadAllGame (get game data)', gameData);
                return _context.abrupt("return", _promise["default"].resolve(gameData));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log('ERROR: GameService, loadAllGame (get game data)', _context.t0);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      function loadAllGame(_x) {
        return _loadAllGame.apply(this, arguments);
      }

      return loadAllGame;
    }()
    /*
     * load game (provided the current game status)
     * @returns updated game status
     */

  }, {
    key: "loadCurrentGame",
    value: function () {
      var _loadCurrentGame = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(tokenId, userAuth) {
        var gameData;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _RestService["default"].getGames([tokenId], userAuth);

              case 3:
                gameData = _context2.sent;
                console.log('SUCCESS: GameService, loadCurrentGame', gameData);
                return _context2.abrupt("return", _promise["default"].resolve(gameData));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.log(tokenId, 'ERROR: GameService, loadCurrentGame', _context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      function loadCurrentGame(_x2, _x3) {
        return _loadCurrentGame.apply(this, arguments);
      }

      return loadCurrentGame;
    }()
  }, {
    key: "loadTournaments",
    value: function () {
      var _loadTournaments = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(userAuth) {
        var onQueueResponse, url, response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                onQueueResponse = function onQueueResponse(response) {
                  if (response.status === 200) {
                    _TournamentStateHelper["default"].handleTournamentListResponse(response.data);
                  }
                };

                url = "".concat(_BuildConstants.IS_KESI_APP || _config["default"].useDrupalContent ? _BuildConstants.QUIZZER_HOST : _BuildConstants.HOST, "/rest/api/v1/").concat(TOURNAMENT_LIST_PATH);
                _context3.next = 5;
                return (0, _HttpRequest.httpPost)(url, null, null, false, null, null, userAuth, onQueueResponse, null, false);

              case 5:
                response = _context3.sent;
                console.log('SUCCESS: GameService, loadTournaments ', response);

                if (!(response.data.success && response.data.tournaments)) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return", _promise["default"].resolve(response.data.tournaments));

              case 11:
                return _context3.abrupt("return", _promise["default"].reject(new Error("ERROR: GameService, loadTournaments ".concat(response))));

              case 12:
                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](0);
                console.log('ERROR: GameService, loadTournaments ', _context3.t0);
                return _context3.abrupt("return", _promise["default"].reject(_context3.t0));

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 14]]);
      }));

      function loadTournaments(_x4) {
        return _loadTournaments.apply(this, arguments);
      }

      return loadTournaments;
    }()
  }, {
    key: "loadSpecificTournament",
    value: function () {
      var _loadSpecificTournament = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(userAuth, tournamentId) {
        var url, response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                url = "".concat(_BuildConstants.IS_KESI_APP || _config["default"].useDrupalContent ? _BuildConstants.QUIZZER_HOST : _BuildConstants.HOST, "/rest/api/v1/").concat(TOURNAMENT_SHOW_PATH, "/").concat(tournamentId);
                _context4.next = 4;
                return (0, _HttpRequest.httpPost)(url, null, null, false, null, null, userAuth, null, null, false);

              case 4:
                response = _context4.sent;
                console.log('SUCCESS: GameService, loafSpecificTournament ', response);

                if (!(response.status === 200 && response.data.success && response.data.tournament)) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt("return", _promise["default"].resolve(response.data.tournament));

              case 10:
                return _context4.abrupt("return", _promise["default"].reject(new Error("ERROR: GameService, loadSpecificTournament ".concat(response))));

              case 11:
                _context4.next = 17;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](0);
                console.log('ERROR: GameService, loadSpecificTournament ', _context4.t0);
                return _context4.abrupt("return", _promise["default"].reject(_context4.t0));

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 13]]);
      }));

      function loadSpecificTournament(_x5, _x6) {
        return _loadSpecificTournament.apply(this, arguments);
      }

      return loadSpecificTournament;
    }()
  }, {
    key: "chooseTournamentTeam",
    value: function () {
      var _chooseTournamentTeam = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(userAuth, tournamentId, teamName) {
        var params, url, response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                params = {
                  tournamentId: tournamentId,
                  teamName: teamName
                };
                url = "".concat(_BuildConstants.IS_KESI_APP || _config["default"].useDrupalContent ? _BuildConstants.QUIZZER_HOST : _BuildConstants.HOST, "/rest/api/v1/").concat(TOURNAMENT_JOIN_TEAM_PATH);
                _context5.next = 5;
                return (0, _HttpRequest.httpPost)(url, params, null, false, 15000, null, userAuth, null, 5000, false);

              case 5:
                response = _context5.sent;
                console.log('SUCCESS: GameService (post team choice)', response);

                if (!(response.status === 200 && response.data.success && response.data.tournament)) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", _promise["default"].resolve(response.data.tournament));

              case 11:
                return _context5.abrupt("return", _promise["default"].reject(new Error("ERROR: GameService, chooseTournamentTeam ".concat(response))));

              case 12:
                _context5.next = 18;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](0);
                console.error('ERROR: GameService (post team choice)', _context5.t0);
                return _context5.abrupt("return", _promise["default"].reject(_context5.t0));

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 14]]);
      }));

      function chooseTournamentTeam(_x7, _x8, _x9) {
        return _chooseTournamentTeam.apply(this, arguments);
      }

      return chooseTournamentTeam;
    }()
  }, {
    key: "leaveTournament",
    value: function () {
      var _leaveTournament = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(userAuth, tournamentId) {
        var params, url, response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                params = {
                  tournamentId: tournamentId
                };
                url = "".concat(_BuildConstants.IS_KESI_APP || _config["default"].useDrupalContent ? _BuildConstants.QUIZZER_HOST : _BuildConstants.HOST, "/rest/api/v1/").concat(TOURNAMENT_LEAVE_PATH);
                _context6.next = 5;
                return (0, _HttpRequest.httpPost)(url, params, null, false, 15000, null, userAuth, null, 5000, false);

              case 5:
                response = _context6.sent;
                console.log('SUCCESS: GameService (post leave tournament)');

                if (!(response.status === 200 && response.data.success)) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", _promise["default"].resolve(response.data));

              case 11:
                return _context6.abrupt("return", _promise["default"].reject(new Error("ERROR: GameService, leaveTournament ".concat(response))));

              case 12:
                _context6.next = 18;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](0);
                console.error('ERROR: GameService (post leave tournament)', _context6.t0);
                return _context6.abrupt("return", _promise["default"].reject(_context6.t0));

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 14]]);
      }));

      function leaveTournament(_x10, _x11) {
        return _leaveTournament.apply(this, arguments);
      }

      return leaveTournament;
    }()
    /*
     * post and load game (provided the current game status)
     * @returns updated game status
     */

  }, {
    key: "postCurrentGame",
    value: function () {
      var _postCurrentGame = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(game, userAuth) {
        var gameToPost, _iterator, _step, round, state, gameObj;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                gameToPost = game;
                /**
                 * Please remove the following if block after the KESI backend can handle multiple choice questions
                 */

                if (_config["default"].useOldQuizObjectAnswerStyle) {
                  // go through game object and replace all values with only one value by the value itself
                  // make copy first
                  gameToPost = JSON.parse((0, _stringify["default"])(game));
                  _iterator = _createForOfIteratorHelper(gameToPost.rounds);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      round = _step.value;

                      if (round.state) {
                        state = round.state;

                        if (state.challenger) {
                          state.challenger = state.challenger.map(function (roundOfChallenger) {
                            var roundObj = roundOfChallenger;

                            if (roundObj.value && roundObj.value.length === 1) {
                              roundObj.value = roundObj.value[0];
                            }

                            return roundObj;
                          });
                        }

                        if (state.opponent) {
                          state.opponent = state.opponent.map(function (roundOfOpponent) {
                            var roundObj = roundOfOpponent;

                            if (roundObj.value && roundObj.value.length === 1) {
                              roundObj.value = roundObj.value[0];
                            }

                            return roundObj;
                          });
                        }
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }

                console.log('SUCCESS: GameService (pre game data)', gameToPost);
                _context7.next = 6;
                return _RestService["default"].postGame(gameToPost, userAuth);

              case 6:
                gameObj = _context7.sent;
                console.log('SUCCESS: GameService (post game data)', gameObj, gameToPost);
                return _context7.abrupt("return", _promise["default"].resolve(gameObj));

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](0);
                console.error('ERROR: GameService (post game data)', _context7.t0);
                return _context7.abrupt("return", _promise["default"].reject(_context7.t0));

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 11]]);
      }));

      function postCurrentGame(_x12, _x13) {
        return _postCurrentGame.apply(this, arguments);
      }

      return postCurrentGame;
    }()
  }, {
    key: "getQuestionSet",
    value: function () {
      var _getQuestionSet = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(game, category, userAuth) {
        var gameObj, response2;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return _RestService["default"].getGames([game.id], userAuth);

              case 3:
                gameObj = _context8.sent;
                delete gameObj.rounds[gameObj.activeRound].categories;
                gameObj.rounds[gameObj.activeRound].category = category;
                _context8.next = 8;
                return _RestService["default"].postGame(gameObj, userAuth);

              case 8:
                response2 = _context8.sent;
                return _context8.abrupt("return", _promise["default"].resolve(response2));

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", _promise["default"].reject(_context8.t0));

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 12]]);
      }));

      function getQuestionSet(_x14, _x15, _x16) {
        return _getQuestionSet.apply(this, arguments);
      }

      return getQuestionSet;
    }()
    /*
     * get categories (provided the current game status)
     * @returns updated game status and list of categories
     */

  }, {
    key: "getGameCategories",
    value: function () {
      var _getGameCategories = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(game, userAuth) {
        var gameData, categories;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                gameData = null;

                if (game.id) {
                  _context9.next = 8;
                  break;
                }

                _context9.next = 5;
                return _RestService["default"].postGame(game, userAuth);

              case 5:
                gameData = _context9.sent;
                _context9.next = 11;
                break;

              case 8:
                _context9.next = 10;
                return _RestService["default"].getGames([game.id], userAuth);

              case 10:
                gameData = _context9.sent;

              case 11:
                categories = GameService.prepareCategoriesList(gameData);
                return _context9.abrupt("return", _promise["default"].resolve({
                  gameData: gameData,
                  categories: categories
                }));

              case 15:
                _context9.prev = 15;
                _context9.t0 = _context9["catch"](0);
                console.error('ERROR: GameService, getGameCategories', _context9.t0);
                return _context9.abrupt("return", _promise["default"].reject(_context9.t0));

              case 19:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 15]]);
      }));

      function getGameCategories(_x17, _x18) {
        return _getGameCategories.apply(this, arguments);
      }

      return getGameCategories;
    }()
  }, {
    key: "getCategories",
    value: function () {
      var _getCategories = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(userAuth) {
        var categories;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return _RestService["default"].getCategories(userAuth);

              case 3:
                categories = _context10.sent;
                return _context10.abrupt("return", _promise["default"].resolve(categories));

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](0);
                console.error('ERROR: GameService, getCategories', _context10.t0);
                return _context10.abrupt("return", _promise["default"].reject(_context10.t0));

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 7]]);
      }));

      function getCategories(_x19) {
        return _getCategories.apply(this, arguments);
      }

      return getCategories;
    }()
  }, {
    key: "getQuestionsForCategory",
    value: function () {
      var _getQuestionsForCategory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(category, userAuth) {
        var categories;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return _RestService["default"].getQuestionsForCategory({
                  rubric: category
                }, userAuth);

              case 3:
                categories = _context11.sent;
                return _context11.abrupt("return", _promise["default"].resolve(categories));

              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11["catch"](0);
                console.error('ERROR: GameService, getQuestionsForCategory', _context11.t0);
                return _context11.abrupt("return", _promise["default"].reject(_context11.t0));

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 7]]);
      }));

      function getQuestionsForCategory(_x20, _x21) {
        return _getQuestionsForCategory.apply(this, arguments);
      }

      return getQuestionsForCategory;
    }()
  }, {
    key: "getAllQuestionsForUser",
    value: function () {
      var _getAllQuestionsForUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(userAuth) {
        var currentSubject, questions;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                currentSubject = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);
                _context12.next = 4;
                return _RestService["default"].getAllQuestionsForUser(userAuth, currentSubject);

              case 4:
                questions = _context12.sent;
                return _context12.abrupt("return", _promise["default"].resolve(questions));

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](0);
                console.error('Error: GameService getAllQuestionsForUser ', _context12.t0);
                return _context12.abrupt("return", _promise["default"].reject(_context12.t0));

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[0, 8]]);
      }));

      function getAllQuestionsForUser(_x22) {
        return _getAllQuestionsForUser.apply(this, arguments);
      }

      return getAllQuestionsForUser;
    }()
  }, {
    key: "getFullHistoryForUser",
    value: function () {
      var _getFullHistoryForUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(userAuth) {
        var subjectId, history;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);
                _context13.next = 4;
                return _RestService["default"].getFullHistoryForUser(userAuth, subjectId);

              case 4:
                history = _context13.sent;
                return _context13.abrupt("return", _promise["default"].resolve(history));

              case 8:
                _context13.prev = 8;
                _context13.t0 = _context13["catch"](0);
                console.error('Error: GameService getFullHistoryForUser ', _context13.t0);
                return _context13.abrupt("return", _promise["default"].reject(_context13.t0));

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[0, 8]]);
      }));

      function getFullHistoryForUser(_x23) {
        return _getFullHistoryForUser.apply(this, arguments);
      }

      return getFullHistoryForUser;
    }()
  }, {
    key: "getPatchForQuestions",
    value: function () {
      var _getPatchForQuestions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(userAuth, version) {
        var subjectId, patch;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);
                _context14.next = 4;
                return _RestService["default"].getPatchForQuestions(userAuth, version, subjectId);

              case 4:
                patch = _context14.sent;
                return _context14.abrupt("return", _promise["default"].resolve(patch));

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](0);
                console.error('Error: GameService getPatchForQuestions ', _context14.t0);
                return _context14.abrupt("return", _promise["default"].reject(_context14.t0));

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[0, 8]]);
      }));

      function getPatchForQuestions(_x24, _x25) {
        return _getPatchForQuestions.apply(this, arguments);
      }

      return getPatchForQuestions;
    }()
  }, {
    key: "postRound",
    value: function () {
      var _postRound = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(postObj, userAuth) {
        var subjectId, response;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);

                if (subjectId) {
                  postObj.subject = subjectId;
                }

                _context15.next = 5;
                return _RestService["default"].postRound(postObj, userAuth);

              case 5:
                response = _context15.sent;
                return _context15.abrupt("return", _promise["default"].resolve(response));

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15["catch"](0);
                console.error('ERROR: GameService, postAnswer', _context15.t0);
                return _context15.abrupt("return", _promise["default"].reject(_context15.t0));

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[0, 9]]);
      }));

      function postRound(_x26, _x27) {
        return _postRound.apply(this, arguments);
      }

      return postRound;
    }()
  }, {
    key: "postAnswer",
    value: function () {
      var _postAnswer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(postObj, userAuth) {
        var subjectId, response;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);

                if (subjectId) {
                  postObj.subject = subjectId;
                }

                _context16.next = 5;
                return _RestService["default"].postAnswer(postObj, userAuth);

              case 5:
                response = _context16.sent;
                return _context16.abrupt("return", _promise["default"].resolve(response));

              case 9:
                _context16.prev = 9;
                _context16.t0 = _context16["catch"](0);
                console.error('ERROR: GameService, postAnswer', _context16.t0);
                return _context16.abrupt("return", _promise["default"].reject(_context16.t0));

              case 13:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[0, 9]]);
      }));

      function postAnswer(_x28, _x29) {
        return _postAnswer.apply(this, arguments);
      }

      return postAnswer;
    }()
  }, {
    key: "postUserFeedback",
    value: function () {
      var _postUserFeedback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(code, deviceuuid, userid, subject, body, type, userAuth) {
        var response;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return _RestService["default"].postUserFeedback({
                  code: code,
                  deviceuuid: deviceuuid,
                  userid: userid,
                  subject: subject,
                  body: body,
                  type: type
                }, userAuth);

              case 3:
                response = _context17.sent;
                return _context17.abrupt("return", _promise["default"].resolve(response));

              case 7:
                _context17.prev = 7;
                _context17.t0 = _context17["catch"](0);
                console.error('ERROR: GameService, postUserFeedback', _context17.t0);
                return _context17.abrupt("return", _promise["default"].reject(_context17.t0));

              case 11:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, null, [[0, 7]]);
      }));

      function postUserFeedback(_x30, _x31, _x32, _x33, _x34, _x35, _x36) {
        return _postUserFeedback.apply(this, arguments);
      }

      return postUserFeedback;
    }()
    /*
     * prepare list of categories for the latest round
     * provided {game} object
     * @returns array of categories
     */

  }, {
    key: "prepareCategoriesList",
    value: function prepareCategoriesList(game) {
      var roundNumber = game.rounds ? game.rounds.length - 1 : 0;
      return game.rounds[roundNumber].categories;
    }
    /*
     * calculate total score per game of challenger and opponent
     * (provided the rounds info of desired game)
     * @returns total score of challenger and opponent
     */

  }, {
    key: "calculateScore",
    value: function calculateScore() {
      var rounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var scores = {
        challenger: 0,
        opponent: 0
      };
      rounds.forEach(function (round) {
        if (round.actionState !== 'chooseCategory') {
          var questions = round.questions;
          var players = (0, _keys["default"])(scores);
          players.forEach(function (player) {
            var sequenceCounter = {}; // add all points of questions not in a sequence

            questions.forEach(function (question) {
              var questionInRound = round.state[player][question.number];

              if (questionInRound && questionInRound.score > 0) {
                if (!question.sequence) {
                  scores[player] += question.score;
                } else {
                  if (!sequenceCounter[question.sequence]) {
                    sequenceCounter[question.sequence] = 1;
                  } else {
                    sequenceCounter[question.sequence] += 1;
                  }
                }
              }
            }); // now check if enough questions were answered correctly in the sequences and add sequence points then

            (0, _keys["default"])(sequenceCounter).forEach(function (sequenceName) {
              var sequenceDefinition = round.sequences[sequenceName];

              if (sequenceDefinition) {
                if (sequenceCounter[sequenceName] >= sequenceDefinition.correctlyAnsweredMin) {
                  scores[player] += sequenceDefinition.points;
                }
              }
            });
          });
        }
      });
      return {
        player1Score: scores['challenger'],
        player2Score: scores['opponent']
      };
    }
  }, {
    key: "getCompletedGameIds",
    value: function getCompletedGameIds(games) {
      var completedGameIds = [];
      games.forEach(function (game) {
        // let game = item.value;
        if (game.finished) {
          completedGameIds.push(game.id);
        }
      });
      console.log('GameService, getCompletedIds', completedGameIds);
      return completedGameIds;
    }
    /*
     * gets network status of device
     */

  }, {
    key: "getNetworkStatus",
    value: function getNetworkStatus() {
      if (_DeviceInfoHelper["default"].isBrowser()) {
        return 'Online';
      } // noinspection UnnecessaryLocalVariableJS (reason: better to read)


      var status = window.navigator.connection && window.navigator.connection.type ? window.navigator.connection.type : 'none';
      return status;
    }
    /*
     * gets last game with each opponent and inserts game status object for each game
     * provided {all the existing games} and {user object}
     * @returns filtered list of games (with game status)
     */

  }, {
    key: "getFilteredGames",
    value: function getFilteredGames(allGame, user) {
      var gameMappedToOpponentId = {};
      allGame.forEach(function (item) {
        var game = item;
        var opponent = game.opponent;

        if (user.id !== game.challenger) {
          opponent = game.challenger;
        }

        if (opponent in gameMappedToOpponentId && new Date(gameMappedToOpponentId[opponent].lastUpdated) > new Date(game.lastUpdated)) {
          return;
        }

        if (game.finished) {
          game.game_status = GAME_STATUS.IS_FINISHED;
        } else if (opponent === game.activePlayer) {
          game.game_status = GAME_STATUS.IS_WAITING;
        } else {
          game.game_status = GAME_STATUS.IS_PLAYABLE;
        }

        gameMappedToOpponentId[opponent] = game;
      });
      return (0, _values["default"])(gameMappedToOpponentId);
    }
  }, {
    key: "loadLastGameWithEachOpponent",
    value: function () {
      var _loadLastGameWithEachOpponent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(user, games) {
        var gameMappedToOpponentId;
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                gameMappedToOpponentId = {};
                _context18.prev = 1;
                console.log('SUCCESS: GameService, loadLastGameWithEachOpponent (get game data)', (0, _stringify["default"])(user), games);
                games.forEach(function (item) {
                  var game = item;
                  var lastUpdated = new Date(game.lastUpdated);
                  var twoDaysAgo = new Date();
                  twoDaysAgo.setDate(twoDaysAgo.getDate() - DAYS_GAME_ACTIVE);

                  if (!_config["default"].allowGamesOlderThan48h && twoDaysAgo.getTime() > lastUpdated.getTime() && game.id && game.id.length > 0) {
                    console.log("loadAllGame ".concat(game.id, " is older than 48 hours -> updated: ").concat(lastUpdated, " / now: ").concat(twoDaysAgo));
                    return;
                  }

                  var opponent = game.opponent;

                  if (user.id !== game.challenger) {
                    opponent = game.challenger;
                  }

                  if (opponent in gameMappedToOpponentId && new Date(gameMappedToOpponentId[opponent].lastUpdated) > new Date(game.lastUpdated)) {
                    return;
                  }

                  if (game.finished) {
                    game.game_status = GAME_STATUS.IS_FINISHED;
                  } else if (opponent === game.activePlayer) {
                    game.game_status = GAME_STATUS.IS_WAITING;
                  } else {
                    game.game_status = GAME_STATUS.IS_PLAYABLE;
                  }

                  gameMappedToOpponentId[opponent] = game;
                });
                return _context18.abrupt("return", _promise["default"].resolve((0, _values["default"])(gameMappedToOpponentId)));

              case 7:
                _context18.prev = 7;
                _context18.t0 = _context18["catch"](1);
                console.log('ERROR: GameService, loadLastGameWithEachOpponent (get game data)', _context18.t0);
                return _context18.abrupt("return", _promise["default"].reject(_context18.t0));

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, null, [[1, 7]]);
      }));

      function loadLastGameWithEachOpponent(_x37, _x38) {
        return _loadLastGameWithEachOpponent.apply(this, arguments);
      }

      return loadLastGameWithEachOpponent;
    }()
  }, {
    key: "getAllExpiredGames",
    value: function () {
      var _getAllExpiredGames = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(games) {
        var expiredGames;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                expiredGames = [];
                _context19.prev = 1;
                games.forEach(function (item) {
                  var game = item;
                  var lastUpdated = new Date(game.lastUpdated);
                  var twoDaysAgo = new Date();
                  twoDaysAgo.setDate(twoDaysAgo.getDate() - DAYS_GAME_ACTIVE);

                  if (twoDaysAgo.getTime() > lastUpdated.getTime() && game.id && game.id.length > 0) {
                    console.log("expiredGames: ".concat(game.id, " is older than 48 hours -> updated: ").concat(lastUpdated, " / now: ").concat(twoDaysAgo));
                    expiredGames.push(game.id);
                  }
                });
                return _context19.abrupt("return", _promise["default"].resolve(expiredGames));

              case 6:
                _context19.prev = 6;
                _context19.t0 = _context19["catch"](1);
                console.log('ERROR: GameService, getAllExpiredGames', _context19.t0);
                return _context19.abrupt("return", _promise["default"].reject(_context19.t0));

              case 10:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, null, [[1, 6]]);
      }));

      function getAllExpiredGames(_x39) {
        return _getAllExpiredGames.apply(this, arguments);
      }

      return getAllExpiredGames;
    }()
  }, {
    key: "loadHistoryBasedFeedback",
    value: function () {
      var _loadHistoryBasedFeedback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(userAuth) {
        var historyBasedFeedback;
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                _context20.next = 3;
                return _RestService["default"].getHistoryBasedFeedback(userAuth);

              case 3:
                historyBasedFeedback = _context20.sent;
                console.log('SUCCESS: GameService, historyBasedFeedback', historyBasedFeedback);
                return _context20.abrupt("return", _promise["default"].resolve(historyBasedFeedback));

              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](0);
                console.log('ERROR: GameService, loadHistoryBasedFeedback', _context20.t0);
                return _context20.abrupt("return", _promise["default"].reject(_context20.t0));

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, null, [[0, 8]]);
      }));

      function loadHistoryBasedFeedback(_x40) {
        return _loadHistoryBasedFeedback.apply(this, arguments);
      }

      return loadHistoryBasedFeedback;
    }()
  }]);
  return GameService;
}();

exports["default"] = GameService;
;